import { jsx as _jsx } from "react/jsx-runtime";
import { Tabs as HeroTabs } from '@heroui/react';
export const Tabs = (props) => {
    return _jsx(HeroTabs, { ...props });
};
export { Tab } from '@heroui/react';
export default Tabs;
//# sourceMappingURL=Tabs.js.map